module.exports = __webpack_public_path__ + "static/media/diaroogle_photo_screenshot.8e844e9c.jpg";